import { gql, useMutation } from '@apollo/client'

import { integrationsClient } from '../../../../utils/apollo/api'
import { useCloseModal, useMoveBack } from '../../../../components/modals/ModalsContext'
import { useProjectId } from '@btime/react-session'

const MUTATION = gql`
  mutation UpsertIntegration($input: IntegrationInput) {
    upsertIntegration(input: $input) {
      id
    }
  }
`

export const useSaveIntegrations = (cleanRequest, moveBackOnSuccess, shouldUseProjectId = false) => {
  const currentProjectId = useProjectId()
  const closeModal = useCloseModal()
  const moveBack = useMoveBack()

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Integrations'], client: integrationsClient })

  const handleRequest = form => {
    const input = shouldUseProjectId ? cleanRequest(form, currentProjectId) : cleanRequest(form)

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        if (moveBackOnSuccess) {
          moveBack()
        } else {
          closeModal()
        }
      }
    })
  }

  return [handleRequest, state]
}
